import { GET_SHOPPING_HISTORY, SHOPPING_HISTORY_ERROR } from "../actions/types";

const initialState = {
  data: [],
  error: false,
  loading: true,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SHOPPING_HISTORY:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case SHOPPING_HISTORY_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
      };
    default:
      return state;
  }
};
